module.exports = __webpack_public_path__ + "img/img8.619cfae1.svg";